package com.schoolconnect.app.feature.attendance

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.heightIn
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.animation.core.LinearEasing
import androidx.compose.animation.core.RepeatMode
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.infiniteRepeatable
import androidx.compose.animation.core.rememberInfiniteTransition
import androidx.compose.animation.core.tween
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.drawBehind
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.geometry.Offset
import androidx.compose.ui.graphics.StrokeCap
import androidx.compose.ui.graphics.drawscope.Stroke
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.style.TextOverflow
import androidx.compose.ui.unit.dp
import com.schoolconnect.app.designsystem.AppBackground
import com.schoolconnect.app.designsystem.AppBorder
import com.schoolconnect.app.designsystem.AppCard
import com.schoolconnect.app.designsystem.AppDialogErrorMessage
import com.schoolconnect.app.designsystem.AppDanger
import com.schoolconnect.app.designsystem.AppDangerSoft
import com.schoolconnect.app.designsystem.AppMuted
import com.schoolconnect.app.designsystem.AppNavy
import com.schoolconnect.app.designsystem.AppPrimary
import com.schoolconnect.app.designsystem.AppPrimarySoft
import com.schoolconnect.app.designsystem.AppSuccess
import com.schoolconnect.app.designsystem.AppSuccessSoft
import com.schoolconnect.app.designsystem.AppText
import com.schoolconnect.app.designsystem.AppWarning
import com.schoolconnect.app.designsystem.AppWarningSoft
import com.schoolconnect.app.designsystem.list.AdminListSummaryCard
import com.schoolconnect.app.feature.common.ShellTopRightActions
import com.schoolconnect.app.feature.common.shellAvatarInitials
import com.schoolconnect.app.feature.common.shellRoleLabel
import com.schoolconnect.app.feature.common.shellRoleSubtitle
import ischoolconnect.sharedui.generated.resources.Res
import ischoolconnect.sharedui.generated.resources.ban
import ischoolconnect.sharedui.generated.resources.calendar
import ischoolconnect.sharedui.generated.resources.chevron_left
import ischoolconnect.sharedui.generated.resources.chevron_right
import ischoolconnect.sharedui.generated.resources.circle_check
import ischoolconnect.sharedui.generated.resources.user
import org.jetbrains.compose.resources.painterResource

@Composable
fun ParentAttendanceScreen(
    state: ParentAttendanceUiState,
    onEvent: (ParentAttendanceUiEvent) -> Unit,
    shellRoleCode: String,
    onChangeRole: () -> Unit,
    onLogout: () -> Unit
) {
    var profileExpanded by remember { mutableStateOf(false) }
    val scrollState = rememberScrollState()
    Column(Modifier.fillMaxSize().background(AppBackground).verticalScroll(scrollState).padding(horizontal = 24.dp, vertical = 20.dp), verticalArrangement = Arrangement.spacedBy(14.dp)) {
        Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.Top) {
            Column(Modifier.weight(1f), verticalArrangement = Arrangement.spacedBy(5.dp)) {
                Text("Attendance", style = MaterialTheme.typography.headlineSmall, fontWeight = FontWeight.Bold, color = AppNavy)
                Text("Track and monitor your child's attendance", style = MaterialTheme.typography.bodyMedium, color = AppNavy)
            }
            ShellTopRightActions(
                roleLabel = shellRoleLabel(shellRoleCode), roleSubtitle = shellRoleSubtitle(shellRoleCode),
                initials = shellAvatarInitials(shellRoleLabel(shellRoleCode)), expanded = profileExpanded,
                onExpandedChange = { profileExpanded = it }, onChangeRole = onChangeRole, onLogout = onLogout
            )
        }

        if (state.isLoading) {
            ParentAttendanceShimmer()
        } else {
            state.selectedChild?.let { child ->
                SelectedAttendanceChild(child)
            }
            ParentAttendanceSummary(state)

        BoxWithConstraints(Modifier.fillMaxWidth()) {
            if (maxWidth >= 900.dp) {
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(18.dp)) {
                    AttendanceCalendar(state, onEvent, Modifier.weight(1.25f))
                    AbsenceHistory(state, Modifier.weight(0.85f))
                }
            } else {
                Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(18.dp)) {
                    AttendanceCalendar(state, onEvent)
                    AbsenceHistory(state)
                }
            }
        }
        TrendCards(state)
        }
        state.errorMessage?.let { AppDialogErrorMessage(it) }
    }
}

@Composable
private fun SelectedAttendanceChild(child: ParentAttendanceChild) {
    AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(8.dp)), containerColor = Color.White) {
        Row(
            Modifier.fillMaxWidth().padding(horizontal = 20.dp, vertical = 14.dp),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(14.dp)
        ) {
            Icon(painterResource(Res.drawable.user), null, tint = AppNavy, modifier = Modifier.size(20.dp))
            Text(child.name, color = AppNavy, fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodyMedium)
            Box(Modifier.width(1.dp).height(20.dp).background(AppBorder))
            Text("Roll No. ${child.rollNumber}", color = AppNavy, style = MaterialTheme.typography.bodyMedium)
            Box(Modifier.width(1.dp).height(20.dp).background(AppBorder))
            Text("Class ${child.classLabel}", color = AppNavy, style = MaterialTheme.typography.bodyMedium)
        }
    }
}

@Composable
private fun ParentAttendanceShimmer() {
    val transition = rememberInfiniteTransition(label = "parent_attendance_shimmer")
    val x by transition.animateFloat(-500f, 1200f, infiniteRepeatable(tween(1200, easing = LinearEasing), RepeatMode.Restart), label = "parent_attendance_shimmer_x")
    val brush = Brush.linearGradient(listOf(AppBorder, Color.White, AppBorder), Offset(x, x), Offset(x + 240f, x + 240f))
    Column(Modifier.fillMaxWidth(), verticalArrangement = Arrangement.spacedBy(14.dp)) {
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) { repeat(4) { Box(Modifier.weight(1f).height(112.dp).background(brush, RoundedCornerShape(10.dp))) } }
        Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(14.dp)) { Box(Modifier.weight(1.25f).height(360.dp).background(brush, RoundedCornerShape(10.dp))); Box(Modifier.weight(.85f).height(360.dp).background(brush, RoundedCornerShape(10.dp))) }
        Box(Modifier.fillMaxWidth().height(120.dp).background(brush, RoundedCornerShape(10.dp)))
    }
}


@Composable private fun ParentAttendanceSummary(state: ParentAttendanceUiState) {
    BoxWithConstraints(Modifier.fillMaxWidth()) {
        val compact = maxWidth < 900.dp
        val items = listOf(
            Triple("Today's Status", state.todayStatus, "Marked ${state.todayMarkedAt}"),
            Triple("Present", state.presentDays.toString(), "Days"),
            Triple("Absent", state.absentDays.toString(), "Days")
        )
        if (compact) Column(verticalArrangement = Arrangement.spacedBy(10.dp)) { AttendancePercentageCard(state); items.forEach { AttendanceMetricCard(it.first, it.second, it.third, it.first != "Absent") } }
        else Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            AttendancePercentageCard(state, Modifier.weight(1.1f)); items.forEach { AttendanceMetricCard(it.first, it.second, it.third, it.first != "Absent", Modifier.weight(1f)) }
        }
    }
}

@Composable private fun AttendancePercentageCard(state: ParentAttendanceUiState, modifier: Modifier = Modifier) {
    AppCard(modifier.border(1.dp, AppPrimarySoft, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Row(Modifier.fillMaxWidth().padding(16.dp), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(14.dp)) {
            Box(Modifier.size(82.dp).drawBehind { drawArc(AppPrimary, -90f, state.attendancePercentage * 3.6f, false, style = Stroke(8.dp.toPx(), cap = StrokeCap.Round)); drawArc(AppBorder, state.attendancePercentage * 3.6f - 90f, 360f - state.attendancePercentage * 3.6f, false, style = Stroke(8.dp.toPx())) }, contentAlignment = Alignment.Center) {
                Text("${state.attendancePercentage}%", color = AppPrimary, fontWeight = FontWeight.ExtraBold, style = MaterialTheme.typography.titleMedium)
            }
            Column(verticalArrangement = Arrangement.spacedBy(3.dp)) { Text("Attendance", color = AppNavy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleSmall); Text("${state.presentDays} / ${state.totalDays}", color = AppNavy, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold); Text("Days", color = AppNavy, style = MaterialTheme.typography.bodySmall) }
        }
    }
}

@Composable private fun AttendanceMetricCard(title: String, value: String, subtitle: String, positive: Boolean, modifier: Modifier = Modifier) {
    val accent = if (positive) AppSuccess else AppDanger; val soft = if (positive) AppSuccessSoft else AppDangerSoft
    AppCard(modifier.border(1.dp, if (positive) AppSuccessSoft else AppDangerSoft, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Row(Modifier.fillMaxWidth().padding(16.dp), verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(12.dp)) {
            Box(Modifier.size(44.dp).background(soft, CircleShape), contentAlignment = Alignment.Center) { Icon(painterResource(if (positive) Res.drawable.circle_check else Res.drawable.ban), null, tint = accent, modifier = Modifier.size(24.dp)) }
            Column(verticalArrangement = Arrangement.spacedBy(3.dp)) { Text(title, color = AppNavy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.titleSmall); Text(value, color = accent, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.ExtraBold); Text(subtitle, color = AppNavy, style = MaterialTheme.typography.labelMedium) }
        }
    }
}

@Composable private fun AttendanceCalendar(state: ParentAttendanceUiState, onEvent: (ParentAttendanceUiEvent) -> Unit, modifier: Modifier = Modifier) {
    AppCard(modifier.heightIn(min = 420.dp).border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) {
            Row(Modifier.fillMaxWidth(), verticalAlignment = Alignment.CenterVertically) {
                IconButton(onClick = { onEvent(ParentAttendanceUiEvent.PreviousMonth) }) { Icon(painterResource(Res.drawable.chevron_left), null, tint = AppNavy) }
                Text(state.monthLabel, Modifier.weight(1f), textAlign = androidx.compose.ui.text.style.TextAlign.Center, color = AppNavy, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold)
                IconButton(onClick = { onEvent(ParentAttendanceUiEvent.NextMonth) }) { Icon(painterResource(Res.drawable.chevron_right), null, tint = AppNavy) }
            }
            Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) { listOf("Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun").forEachIndexed { index, label -> Text(label, Modifier.weight(1f), textAlign = TextAlign.Center, color = if (index == 6) AppDanger else AppNavy, style = MaterialTheme.typography.labelMedium, fontWeight = FontWeight.Bold) } }
            val cells = List(state.calendarStartOffset) { null } + state.calendarDays + List(42 - state.calendarStartOffset - state.calendarDays.size) { null }
            cells.chunked(7).forEach { week ->
                Row(Modifier.fillMaxWidth()) {
                    week.forEachIndexed { dayIndex, day ->
                        val isSunday = dayIndex == 6
                        val isToday = day != null && day.day == state.todayDay
                        CalendarCell(day, Modifier.weight(1f), isSunday, isToday)
                    }
                }
            }
            Column(verticalArrangement = Arrangement.spacedBy(6.dp)) {
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) { Legend(AppSuccessSoft, "Present"); Legend(Color(0xFFF0F0F0), "Holiday (Sunday)"); Legend(AppDangerSoft, "A  Absent") }
                Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(12.dp), verticalAlignment = Alignment.CenterVertically) { Legend(AppDangerSoft, "A-M  Absent (Morning)"); Legend(AppDangerSoft, "A-A  Absent (Afternoon)") }
            }
        }
    }
}

@Composable private fun CalendarCell(day: ParentAttendanceDay?, modifier: Modifier, isSunday: Boolean, isToday: Boolean) {
    val statusColor = when (day?.status) { ParentAttendanceStatus.PRESENT -> AppSuccessSoft; ParentAttendanceStatus.HOLIDAY -> Color(0xFFF0F0F0); ParentAttendanceStatus.ABSENT, ParentAttendanceStatus.ABSENT_MORNING, ParentAttendanceStatus.ABSENT_AFTERNOON -> AppDangerSoft; ParentAttendanceStatus.LATE, ParentAttendanceStatus.EXCUSED -> AppWarningSoft; else -> Color.White }
    val bg = if (isSunday) Color(0xFFF0F0F0) else statusColor
    Box(
        modifier.padding(1.dp).height(46.dp).background(bg, RoundedCornerShape(5.dp))
            .border(if (isToday) 1.5.dp else 1.dp, if (isToday) AppPrimary else AppBorder, RoundedCornerShape(5.dp)),
        contentAlignment = Alignment.Center
    ) {
        if (day != null) {
            Column(horizontalAlignment = Alignment.CenterHorizontally) {
                Text(day.day.toString(), color = when {
                    isToday -> AppPrimary
                    isSunday -> AppMuted
                    day.status == ParentAttendanceStatus.ABSENT || day.status == ParentAttendanceStatus.ABSENT_MORNING || day.status == ParentAttendanceStatus.ABSENT_AFTERNOON -> AppDanger
                    else -> Color.Black
                }, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodyMedium)
                if (day.status == ParentAttendanceStatus.ABSENT) Text("A", color = AppDanger, style = MaterialTheme.typography.labelSmall)
                else if (day.status == ParentAttendanceStatus.ABSENT_MORNING) Text("A-M", color = AppDanger, style = MaterialTheme.typography.labelSmall)
                else if (day.status == ParentAttendanceStatus.ABSENT_AFTERNOON) Text("A-A", color = AppDanger, style = MaterialTheme.typography.labelSmall)
                else if (day.status == ParentAttendanceStatus.LATE) Text("L", color = AppWarning, style = MaterialTheme.typography.labelSmall)
                else if (day.status == ParentAttendanceStatus.EXCUSED) Text("E", color = AppWarning, style = MaterialTheme.typography.labelSmall)
            }
        }
    }
}

@Composable private fun Legend(color: Color, label: String) { Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(5.dp)) { Box(Modifier.size(10.dp).background(color, RoundedCornerShape(3.dp))); Text(label, color = AppNavy, style = MaterialTheme.typography.labelSmall, maxLines = 1, overflow = TextOverflow.Ellipsis) } }

@Composable private fun AbsenceHistory(state: ParentAttendanceUiState, modifier: Modifier = Modifier) {
    AppCard(modifier.heightIn(min = 420.dp).border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) {
        Column(Modifier.fillMaxWidth().padding(16.dp), verticalArrangement = Arrangement.spacedBy(0.dp)) {
            Text("Absence History", color = AppNavy, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold, modifier = Modifier.padding(bottom = 10.dp))
            Row(Modifier.fillMaxWidth().padding(vertical = 8.dp)) {
                Text("Date", Modifier.weight(1f), color = AppNavy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodySmall)
                Text("Status", Modifier.weight(1f), color = AppNavy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodySmall)
            }
            Box(Modifier.fillMaxWidth().height(1.dp).background(AppBorder))
            if (state.absenceHistory.isEmpty()) {
                Row(Modifier.fillMaxWidth().height(44.dp), verticalAlignment = Alignment.CenterVertically) {
                    Text("No absence records", Modifier.fillMaxWidth(), color = AppMuted, style = MaterialTheme.typography.bodySmall, textAlign = TextAlign.Center)
                }
                Box(Modifier.fillMaxWidth().height(1.dp).background(AppBorder))
            } else {
                state.absenceHistory.forEach { row ->
                    Row(Modifier.fillMaxWidth().height(40.dp), verticalAlignment = Alignment.CenterVertically) {
                        Text(row.date, Modifier.weight(1f), color = AppNavy, fontWeight = FontWeight.SemiBold, style = MaterialTheme.typography.bodySmall)
                        Text(row.status, Modifier.weight(1f), color = AppDanger, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodySmall)
                    }
                    Box(Modifier.fillMaxWidth().height(1.dp).background(AppBorder))
                }
            }
        }
    }
}

@Composable private fun TrendCards(state: ParentAttendanceUiState) {
    AppCard(Modifier.fillMaxWidth().border(1.dp, AppBorder, RoundedCornerShape(10.dp)), containerColor = Color.White) { Column(Modifier.padding(16.dp), verticalArrangement = Arrangement.spacedBy(10.dp)) { Text("Attendance Trend", color = AppNavy, style = MaterialTheme.typography.titleMedium, fontWeight = FontWeight.Bold); BoxWithConstraints(Modifier.fillMaxWidth()) { val compact = maxWidth < 800.dp; if (compact) Column(verticalArrangement = Arrangement.spacedBy(8.dp)) { state.trend.forEach { TrendCard(it, Modifier.fillMaxWidth()) } } else Row(Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(10.dp)) { state.trend.forEach { TrendCard(it, Modifier.weight(1f)) } } } } }
}

@Composable private fun TrendCard(item: ParentAttendanceTrend, modifier: Modifier) { val color = if (item.percentage >= 96) AppSuccess else if (item.percentage >= 95) com.schoolconnect.app.designsystem.AppWarning else AppPrimary; AppCard(modifier.border(1.dp, if (item.selected) AppPrimary else AppBorder, RoundedCornerShape(8.dp)), containerColor = Color.White) { Column(Modifier.padding(12.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) { Text(item.month, color = AppNavy, fontWeight = FontWeight.Bold, style = MaterialTheme.typography.bodySmall); Text("${item.percentage}%", color = color, style = MaterialTheme.typography.titleLarge, fontWeight = FontWeight.ExtraBold) } } }
